var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TitledContext } from './TitledContext';
import { TitledProvider } from './TitledProvider';
export const Titled = (_a) => {
    var { title } = _a, otherProps = __rest(_a, ["title"]);
    return (React.createElement(TitledContext.Consumer, null, (value) => (React.createElement(TitledProvider, Object.assign({ title: typeof title === 'string' ? () => title : title }, otherProps, { resetHeight: value === null || value === void 0 ? void 0 : value.resetHeight, updateParent: value === null || value === void 0 ? void 0 : value.updateParent })))));
};
